import React from 'react'
import { useDispatch } from 'react-redux'

import Editor, { EditorProps } from 'components/Shared/Editor'
import type { Dispatch } from 'redux'
import { useAppSelector } from 'redux/Hook'
import { FroalaConfig } from 'components/Shared/Editor/FroalaConfig'

interface ExtendedEditorProps extends Omit<EditorProps, 'onChange'> {
  label: string
  id?: string
  name: string
  onChange: (key: string, value: string, dispatch: Dispatch) => void
}

const FroalaEditor = (props: ExtendedEditorProps) => {
  const { label, onChange, id, ...rest } = props
  const toolState = useAppSelector(
    (state) => state.toolBuilder.toolBuilder,
  ) as Record<string, any>
  const value = toolState[id || label]
  const dispatch = useDispatch()

  return (
    <Editor
      {...rest}
      value={value}
      placeholder={label}
      config={FroalaConfig}
      onChange={(event) => {
        const { name, value } = event?.target || {}
        return onChange(name || id || label, value, dispatch)
      }}
    />
  )
}

export default FroalaEditor
